import SeoAuditExperience from "../components/SeoAuditExperience";

export default function SeoAudit() {
  return <SeoAuditExperience mode="guest" />;
}
